module.exports = __webpack_public_path__ + "img/7news.3fc8d853.png";